import React from "react";
import styles from "../../workshopSchedule.module.scss";

const ViewMore = ({
    setExpanded,
    isExpanded,
}: {
    setExpanded: Function;
    isExpanded: Boolean;
}) => {
    return (
        <div
            role="presentation"
            className={styles.expandDescription}
            onClick={() => setExpanded(!isExpanded)}
        >
            {(isExpanded && <>View Less&#9650;</>) || <>View More &#9660;</>}
        </div>
    );
};

export default ViewMore;
